/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrackAddedToPlaylistNotificationActionData
 */
export interface TrackAddedToPlaylistNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof TrackAddedToPlaylistNotificationActionData
     */
    trackId: string;
    /**
     * 
     * @type {string}
     * @memberof TrackAddedToPlaylistNotificationActionData
     */
    playlistId: string;
    /**
     * 
     * @type {string}
     * @memberof TrackAddedToPlaylistNotificationActionData
     */
    playlistOwnerId: string;
}

/**
 * Check if a given object implements the TrackAddedToPlaylistNotificationActionData interface.
 */
export function instanceOfTrackAddedToPlaylistNotificationActionData(value: object): value is TrackAddedToPlaylistNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "trackId" in value && value["trackId"] !== undefined;
    isInstance = isInstance && "playlistId" in value && value["playlistId"] !== undefined;
    isInstance = isInstance && "playlistOwnerId" in value && value["playlistOwnerId"] !== undefined;

    return isInstance;
}

export function TrackAddedToPlaylistNotificationActionDataFromJSON(json: any): TrackAddedToPlaylistNotificationActionData {
    return TrackAddedToPlaylistNotificationActionDataFromJSONTyped(json, false);
}

export function TrackAddedToPlaylistNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackAddedToPlaylistNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'trackId': json['track_id'],
        'playlistId': json['playlist_id'],
        'playlistOwnerId': json['playlist_owner_id'],
    };
}

export function TrackAddedToPlaylistNotificationActionDataToJSON(value?: TrackAddedToPlaylistNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'track_id': value.trackId,
        'playlist_id': value.playlistId,
        'playlist_owner_id': value.playlistOwnerId,
    };
}

